<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9Xl9LA/tc-custom/9781467466066.jpg?1728069719335" alt="This image is the cover for the book Faith Seeking Understanding, Fourth ed."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faith Seeking Understanding, Fourth ed.
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An authoritative and beloved textbook, updated for the current generation of theology students.</b></p><p>Daniel L. Migliore’s classic theology textbook returns in a new edition, revised and supplemented with fresh material. <i>Faith Seeking Understanding</i> covers fundamental topics for budding theologians, from biblical hermeneutics to the incarnation to the life of faith. As in previous editions, the material culminates in four imaginative dialogues between prominent thinkers to illustrate major theological debates.</p><p>In addition to updates throughout the text, the fourth edition also includes a new introduction and an additional chapter on Christology. Students will appreciate the textbook’s accessible style, comprehensive reading recommendations, and glossary of theological terms.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel L. Migliore
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Daniel L. Migliore</B>&#160;is Charles Hodge Professor Emeritus of Systematic Theology at Princeton Theological Seminary.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23e237f7